import React from "react";

function AdminDash() {
  return (
    <section className="services-section">
      <div className="auto-container">
        <div className="sec-title style-two">
          <h2>Admin Dashboard</h2>
          <div className="text">
            Bring to the table win-win survival strategies to ensure proactive
            domination. At the end of the day, going forward, a new normal that
            has evolved from generation X is on the runway heading towards a
            streamlined cloud solution.{" "}
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>OPEN FOR ALL</h5>
              <h2>All Orders</h2>
              <a href="#" className="read-more">
                LIST OF ORDERS +
              </a>
              <div className="icon">
                <span className="flaticon-power"></span>
              </div>
            </div>
          </div>
          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>OPEN FOR LEADS</h5>
              <h2>New Orders</h2>
              <a href="#" className="read-more">
                ADD ORDER +
              </a>
              <div className="icon">
                <span className="flaticon-power"></span>
              </div>
            </div>
          </div>
          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>OPEN FOR ADMINS</h5>
              <h2>Employees</h2>
              <a href="#" className="read-more">
                LIST OF EMPLOYEES +
              </a>

              <div className="icon">
                <span className="flaticon-gearbox"></span>
              </div>
            </div>
          </div>
          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>OPEN FOR ADMIN</h5>
              <h2>Add Employee</h2>
              <a href="#" className="read-more">
                READ MORE +
              </a>
              <div className="icon">
                <span className="flaticon-brake-disc"></span>
              </div>
            </div>
          </div>
          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>SERVICE AND REPAIR</h5>

              <h2>Engine Service&Repair</h2>
              <a href="#" className="read-more">
                READ MORE +
              </a>
              <div className="icon">
                <span className="flaticon-car-engine"></span>
              </div>
            </div>
          </div>
          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>SERVICE AND REPAIR</h5>
              <h2>Tyre and Wheels</h2>
              <a href="#" className="read-more">
                READ MORE +
              </a>
              <div className="icon">
                <span className="flaticon-tire"></span>
              </div>
            </div>
          </div>

          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>SERVICE AND REPAIR</h5>
              <h2>Denting and Painting</h2>
              <a href="#" className="read-more">
                READ MORE +
              </a>

              <div className="icon">
                <span className="flaticon-spray-gun"></span>
              </div>
            </div>
          </div>

          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>SERVICE AND REPAIR</h5>
              <h2>Engine Service&Repair</h2>
              <a href="#" className="read-more">
                READ MORE +
              </a>
              <div className="icon">
                <span className="flaticon-car-engine"></span>
              </div>
            </div>
          </div>

          <div className="col-lg-4 service-block-one">
            <div className="inner-box hvr-float-shadow">
              <h5>SERVICE AND REPAIR</h5>
              <h2>Tyre and Wheels</h2>
              <a href="#" className="read-more">
                READ MORE +
              </a>
              <div className="icon">
                <span className="flaticon-tire"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminDash;
